import 'react-multi-carousel/lib/styles.css';
import { Container, Col } from "react-bootstrap";
import experiencesBG from "./img/Experiences.gif";
import './Tools.css';
import { ToolsCard } from "./ToolsCard";
import toolsData from "../../assets/data/tools.json"; //tools data

export const Tools = () => {
  return (
    <section id="tools">
      <Container>
        <Col>
          <div className="tools-bx" style={{ backgroundImage: `url(${experiencesBG})` }}>
            <div className="tools-bg" >
              <div className='tools'>
                <h2>
                  Tools
                </h2>
                <p>
                  Here are some tools that I have worked with
                </p>
              </div>
              <div className='tools-container'>
                {
                  toolsData.tools.map((project, index) => {
                    return (
                      <ToolsCard key={index} {...project} />
                    )
                  })
                }
              </div>
            </div>
          </div>
        </Col>
      </Container>
    </section>
  )
}